export enum PROCESSING_STATUS {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export const PROCESSING_STATUS_OPTIONS = [
  { label: 'Chờ duyệt', value: PROCESSING_STATUS.PENDING },
  { label: 'Đã duyệt', value: PROCESSING_STATUS.APPROVED },
  { label: 'Từ chối', value: PROCESSING_STATUS.REJECTED },
]

export enum TRANSACTION_TYPE {
  SELL = 'sell',
  RENT = 'rent',
}
export const TRANSACTION_TYPE_OPTIONS = [
  { label: 'Bán', value: TRANSACTION_TYPE.SELL },
  { label: 'Cho thuê', value: TRANSACTION_TYPE.RENT },
]

export enum LISTING_TYPE {
  CLASSIFIED = 'classified',
  OWNER = 'owner',
  EXCLUSIVE = 'exclusive',
}

export const LISTING_TYPE_OPTIONS = [
  { label: 'Tin môi giới', value: LISTING_TYPE.CLASSIFIED, color: 'secondary' },
  { label: 'Tin chính chủ', value: LISTING_TYPE.OWNER, color: 'info' },
  { label: 'Tin độc quyền', value: LISTING_TYPE.EXCLUSIVE, color: 'warn' },
]

export enum REAL_ESTATE_CATEGORY {
  APARTMENT = 'apartment',
  HOUSE = 'house',
  HOUSE_IN_ALLEY = 'house_in_alley',
  LAND = 'land',
  SHOPHOUSE = 'shop_house',
  VILLA = 'villa',
  CONDOTEL = 'condotel',
  OFFICE = 'office',
  OTHER = 'other',
  HOSLET = 'hostel',
  HOSTEL_BUILDING = 'hostel_building',
}

// Synced with App REAL_ESTATE_CATEGORY_OPTIONS — only active categories
export const REAL_ESTATE_CATEGORY_OPTIONS = [
  { label: 'Đất nền', value: REAL_ESTATE_CATEGORY.LAND },
  { label: 'Nhà ở', value: REAL_ESTATE_CATEGORY.HOUSE },
  { label: 'Căn hộ', value: REAL_ESTATE_CATEGORY.APARTMENT },
  { label: 'Văn phòng', value: REAL_ESTATE_CATEGORY.OFFICE },
  { label: 'Phòng trọ', value: REAL_ESTATE_CATEGORY.HOSLET },
  { label: 'Toà nhà / Dãy phòng trọ', value: REAL_ESTATE_CATEGORY.HOSTEL_BUILDING },
  { label: 'Khác', value: REAL_ESTATE_CATEGORY.OTHER },
]

export const USAGE_AREA = [
  REAL_ESTATE_CATEGORY.APARTMENT,
  REAL_ESTATE_CATEGORY.HOUSE,
  REAL_ESTATE_CATEGORY.HOUSE_IN_ALLEY,
  // REAL_ESTATE_CATEGORY.LAND,
  REAL_ESTATE_CATEGORY.SHOPHOUSE,
  REAL_ESTATE_CATEGORY.VILLA,
  REAL_ESTATE_CATEGORY.CONDOTEL,
  REAL_ESTATE_CATEGORY.OFFICE,
  REAL_ESTATE_CATEGORY.OTHER,
  REAL_ESTATE_CATEGORY.HOSLET,
  REAL_ESTATE_CATEGORY.HOSTEL_BUILDING,
]

export enum DIRECTION {
  EAST = 'east',
  WEST = 'west',
  SOUTH = 'south',
  NORTH = 'north',
  NORTHEAST = 'northeast',
  NORTHWEST = 'northwest',
  SOUTHEAST = 'southeast',
  SOUTHWEST = 'southwest',
}

export const DIRECTION_OPTIONS = [
  { label: 'Đông', value: DIRECTION.EAST },
  { label: 'Tây', value: DIRECTION.WEST },
  { label: 'Nam', value: DIRECTION.SOUTH },
  { label: 'Bắc', value: DIRECTION.NORTH },
  { label: 'Đông Bắc', value: DIRECTION.NORTHEAST },
  { label: 'Tây Bắc', value: DIRECTION.NORTHWEST },
  { label: 'Đông Nam', value: DIRECTION.SOUTHEAST },
  { label: 'Tây Nam', value: DIRECTION.SOUTHWEST },
]

// unlisted: "--", listing: "Đang list", active: "Đang rao", flash_offer: "Flash offer"
export enum LISTING_STASTUS {
  LISTING = 'listing',
  ACTIVE = 'active',
  FLASH_OFFER = 'flash_offer',
}

export const LISTING_STATUS_OPTIONS = [
  { label: 'Đang list', value: LISTING_STASTUS.LISTING },
  { label: 'Đang rao', value: LISTING_STASTUS.ACTIVE },
  { label: 'Flash offer', value: LISTING_STASTUS.FLASH_OFFER },
]

// pending, approved, rejected, completed, expired
export enum LISTING_PROCESSING_STATUS {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  COMPLETED = 'completed',
  EXPIRED = 'expired',
}

export const LISTING_PROCESSING_STATUS_OPTIONS = [
  { label: 'Chờ duyệt', value: LISTING_PROCESSING_STATUS.PENDING, color: 'warn' },
  { label: 'Đã duyệt', value: LISTING_PROCESSING_STATUS.APPROVED, color: 'success' },
  { label: 'Từ chối', value: LISTING_PROCESSING_STATUS.REJECTED, color: 'danger' },
  { label: 'Hoàn thành', value: LISTING_PROCESSING_STATUS.COMPLETED, color: 'success' },
  { label: 'Hết hạn', value: LISTING_PROCESSING_STATUS.EXPIRED, color: 'secondary' },
]

export enum PRICE_TYPE {
  FIXED_PRICE = 'fixed_price',
  SQM_PMONTH = 'sqm_pmonth',
  PMONTH = 'pmonth',
  SQM = 'sqm',
}

export const PRICE_TYPE_OPTIONS = [
  { label: 'Cố định', value: PRICE_TYPE.FIXED_PRICE },
  { label: 'm²/tháng', value: PRICE_TYPE.SQM_PMONTH },
  { label: 'Mỗi tháng', value: PRICE_TYPE.PMONTH },
  { label: 'VNĐ/m²', value: PRICE_TYPE.SQM },
]

// Sell price type options (for sell transaction)
export const PRICE_TYPE_SELL_OPTIONS = [
  { label: 'Cố định', value: PRICE_TYPE.FIXED_PRICE },
  { label: 'VNĐ/m²', value: PRICE_TYPE.SQM_PMONTH },
]

// Rent price type options (for rent transaction)
export const PRICE_TYPE_RENT_OPTIONS = [
  { label: 'Giá thuê theo m²/tháng', value: PRICE_TYPE.SQM_PMONTH },
  { label: 'Giá thuê mỗi tháng', value: PRICE_TYPE.PMONTH },
]

// Map price_type value → display unit label
export const PRICE_TYPE_UNIT_MAP: Record<string, string> = {
  [PRICE_TYPE.FIXED_PRICE]: 'VNĐ',
  [PRICE_TYPE.SQM]: 'VNĐ/m²',
  [PRICE_TYPE.SQM_PMONTH]: 'VNĐ/m²/tháng',
  [PRICE_TYPE.PMONTH]: 'VNĐ/tháng',
}

export enum POSTER_TYPE {
  COMPANY = 'company',
  USER = 'user',
}

export const HISTORY_OPTIONS = [
  { label: 'Giá', value: 'price' },
  { label: 'Thông tin chủ sở hữu', value: 'owner_info' },
  { label: 'Thông tin xây dựng', value: 'construction_info' },
  { label: 'Thông tin quy hoạch', value: 'planning_info' },
  { label: 'Thông tin khác', value: 'other_info' },
  { label: 'Tình trạng giao dịch', value: 'transaction_status' },
]

export const REQUEST_TYPE = {
  DELETE: 'delete',
  UPDATE: 'update',
  POST: 'post',
}

export const REQUEST_TYPE_OPTIONS = [
  { label: 'Xoá tin', value: REQUEST_TYPE.DELETE, color: 'danger' },
  { label: 'Chỉnh sửa tin', value: REQUEST_TYPE.UPDATE, color: 'warning' },
  { label: 'Đăng tin', value: REQUEST_TYPE.POST, color: 'info' },
]

export const landUseCodes = [
  { code: 'LUC', description: 'Đất chuyên trồng lúa nước' },
  { code: 'LUK', description: 'Đất trồng lúa nước còn lại ' },
  { code: 'LUN', description: 'Đất lúa nương' },
  { code: 'BHK', description: 'Đất bằng trồng cây hàng năm khác ' },
  { code: 'NHK', description: 'Đất nương rẫy trồng cây hàng năm khác' },
  { code: 'CLN', description: 'Đất trồng cây lâu năm' },
  { code: 'RSX', description: 'Đất rừng sản xuất' },
  { code: 'RPH', description: 'Đất rừng phòng hộ' },
  { code: 'RDD', description: 'Đất rừng chuyên dụng ' },
  { code: 'NTS', description: 'Đất nuôi trồng thủy sản' },
  { code: 'LMU', description: 'Đất làm muối ' },
  { code: 'NKH', description: 'Đất nông nghiệp khác ' },
  { code: 'ONT', description: 'Đất ở nông thôn' },
  { code: 'ODT', description: 'Đất ở đô thị ' },
  { code: 'TSC', description: 'Đất xây dựng trụ sở cơ quan' },
  { code: 'DTS', description: 'Đất xây dựng trụ sở của tổ chức sự nghiệp' },
  { code: 'DVH', description: 'Đất xây dựng cơ sở văn hóa ' },
  { code: 'DYT', description: 'Đất xây dựng cơ sở y tế' },
  { code: 'DGD', description: 'Đất xây dựng cơ sở giáo dục và đào tạo ' },
  { code: 'DTT', description: 'Đất xây dựng cơ sở thể dục thể thao' },
  { code: 'DKH', description: 'Đất xây dựng cơ sở khoa học và công nghệ ' },
  { code: 'DXH', description: 'Đất xây dựng cơ sở dịch vụ xã hội' },
  { code: 'DNG', description: 'Đất xây dựng cơ sở ngoại giao' },
  { code: 'DSK', description: 'Đất xây dựng công trình sự nghiệp khác ' },
  { code: 'CQP', description: 'Đất quốc phòng ' },
  { code: 'CAN', description: 'Đất an ninh' },
  { code: 'SKK', description: 'Đất khu công nghiệp' },
  { code: 'SKT', description: 'Đất khu chế xuất ' },
  { code: 'SKN', description: 'Đất cụm công nghiệp' },
  { code: 'SKC', description: 'Đất cơ sở sản xuất phi nông nghiệp ' },
  { code: 'TMD', description: 'Đất thương mại và dịch vụ' },
  { code: 'SKS', description: 'Đất sử dụng cho hoạt động khoáng sản ' },
  { code: 'SKX', description: 'Đất sản xuất vật liệu xây dựng, làm đồ gốm ' },
  { code: 'DGT', description: 'Đất giao thông ' },
  { code: 'DTL', description: 'Đất thủy lợi ' },
  { code: 'DNL', description: 'Đất công trình năng lượng' },
  { code: 'DBV', description: 'Đất công trình bưu chính viễn thông' },
  { code: 'DSH', description: 'Đất sinh hoạt cộng đồng' },
  { code: 'DKV', description: 'Đất khu vui chơi, giải trí công cộng ' },
  { code: 'DCH', description: 'Đất chợ' },
  { code: 'DDT', description: 'Đất có di tích lịch sử – văn hóa ' },
  { code: 'DDL', description: 'Đất danh lam thắng cảnh' },
  { code: 'DRA', description: 'Đất bãi thải, xử lý chất thải' },
  { code: 'DCK', description: 'Đất công trình công cộng khác' },
  { code: 'TON', description: 'Đất cơ sở tôn giáo ' },
  { code: 'TIN', description: 'Đất cơ sở tín ngưỡng ' },
  {
    code: 'NTD',
    description: 'Đất làm nghĩa trang, nghĩa địa, nhà tang lễ, nhà hỏa táng',
  },
  { code: 'SON', description: 'Đất sông, ngòi, kênh, rạch, suối ' },
  { code: 'MNC', description: 'Đất cơ mặt nước chuyên dùng' },
  { code: 'PNK', description: 'Đất phi nông nghiệp khác ' },
  { code: 'BCS', description: 'Đất bằng chưa sử dụng ' },
  { code: 'DCS', description: 'Đất đồi núi chưa sử dụng' },
  { code: 'NCS', description: 'Núi đá không có rừng cây ' },
]

// ─── Legal Status ──────────────────────────────────────────────────────────────
export enum LEGAL_STATUS {
  HAS_RED_BOOK = 'has_lurc',
  WAITING_RED_BOOK = 'waiting_lurc',
  NO_RED_BOOK = 'no_lurc',
  SHARED_RED_BOOK = 'shared_lurc',
  NOTARIZED_DOCUMENT = 'notarized_document',
  HANDWRITTER_PAPER = 'handwritter_paper',
}

export const LEGAL_STATUS_OPTIONS = [
  { label: 'Đã có sổ', value: LEGAL_STATUS.HAS_RED_BOOK },
  { label: 'Đang chờ sổ', value: LEGAL_STATUS.WAITING_RED_BOOK },
  { label: 'Không có sổ', value: LEGAL_STATUS.NO_RED_BOOK },
  { label: 'Sổ chung / công chứng vi bằng', value: LEGAL_STATUS.SHARED_RED_BOOK },
  { label: 'Giấy tờ viết tay', value: LEGAL_STATUS.HANDWRITTER_PAPER },
]

// ─── Land Type ─────────────────────────────────────────────────────────────────
export enum LAND_TYPE {
  ODT = 'ODT',
  ONT = 'ONT',
  CLN = 'CLN',
  LUC = 'LUC',
  LUK = 'LUK',
  LUN = 'LUN',
  HNK = 'HNK',
  NHK = 'NHK',
  NTS = 'NTS',
  NTD = 'NTD',
  SKC = 'SKC',
  TMD = 'TMD',
  SKS = 'SKS',
  SKX = 'SKX',
  RSX = 'RSX',
}

export const LAND_TYPE_OPTIONS = [
  { label: 'Đất ở tại đô thị', value: LAND_TYPE.ODT },
  { label: 'Đất ở tại nông thôn', value: LAND_TYPE.ONT },
  { label: 'Đất trồng cây lâu năm', value: LAND_TYPE.CLN },
  { label: 'Đất chuyên trồng lúa nước', value: LAND_TYPE.LUC },
  { label: 'Đất trồng lúa nước còn lại', value: LAND_TYPE.LUK },
  { label: 'Đất trồng lúa nương', value: LAND_TYPE.LUN },
  { label: 'Đất trồng cây hàng năm khác', value: LAND_TYPE.HNK },
  { label: 'Đất nông nghiệp khác', value: LAND_TYPE.NHK },
  { label: 'Đất nuôi trồng thủy sản', value: LAND_TYPE.NTS },
  { label: 'Đất làm muối', value: LAND_TYPE.NTD },
  { label: 'Đất cơ sở sản xuất phi nông nghiệp', value: LAND_TYPE.SKC },
  { label: 'Đất thương mại, dịch vụ', value: LAND_TYPE.TMD },
  { label: 'Đất sử dụng cho hoạt động khoáng sản', value: LAND_TYPE.SKS },
  { label: 'Đất sản xuất vật liệu xây dựng, làm đồ gốm', value: LAND_TYPE.SKX },
  { label: 'Đất rừng sản xuất', value: LAND_TYPE.RSX },
]

// ─── Handover Status ───────────────────────────────────────────────────────────
export enum HANDOVER_STATUS {
  HANDED = 'handed',
  WAITING = 'waiting',
  UNDER_CONSTRUCTION = 'under_construction',
  RESALE = 'resale',
}

export const HANDOVER_STATUS_OPTIONS = [
  { label: 'Đã bàn giao', value: HANDOVER_STATUS.HANDED },
  { label: 'Đang bàn giao', value: HANDOVER_STATUS.WAITING },
  { label: 'Đang xây dựng', value: HANDOVER_STATUS.UNDER_CONSTRUCTION },
  { label: 'Mua bán lại', value: HANDOVER_STATUS.RESALE },
]

// ─── Apartment / Property Type ─────────────────────────────────────────────────
export enum APARTMENT_TYPE {
  TOWNHOUSE = 'townhouse',
  ALLEY_HOUSE = 'alley_house',
  DETACHED_HOUSE = 'detached_house',
  VILLA = 'villa',
  APARTMENT = 'apartment',
  STUDIO = 'studio',
  DUPLEX = 'duplex',
  PENTHOUSE = 'penthouse',
  SHOPHOUSE = 'shophouse',
  WAREHOUSE = 'warehouse',
  CONDOTEL = 'condotel',
}

// Loại hình cho Nhà ở
export const HOUSE_TYPE_OPTIONS = [
  { label: 'Nhà mặt phố', value: APARTMENT_TYPE.TOWNHOUSE },
  { label: 'Nhà trong ngõ', value: APARTMENT_TYPE.ALLEY_HOUSE },
  { label: 'Nhà riêng', value: APARTMENT_TYPE.DETACHED_HOUSE },
  { label: 'Biệt thự', value: APARTMENT_TYPE.VILLA },
  { label: 'Shophouse', value: APARTMENT_TYPE.SHOPHOUSE },
  { label: 'Kho xưởng', value: APARTMENT_TYPE.WAREHOUSE },
]

// Loại hình cho Căn hộ
export const APARTMENT_TYPE_OPTIONS = [
  { label: 'Chung cư', value: APARTMENT_TYPE.APARTMENT },
  { label: 'Condotel', value: APARTMENT_TYPE.CONDOTEL },
  { label: 'Studio', value: APARTMENT_TYPE.STUDIO },
  { label: 'Duplex', value: APARTMENT_TYPE.DUPLEX },
  { label: 'Penthouse', value: APARTMENT_TYPE.PENTHOUSE },
]

// ─── Furniture Status ──────────────────────────────────────────────────────────
export enum FURNITURE_STATUS {
  NONE = 'none', // Bàn giao thô
  BASIC = 'basic', // Hoàn thiện cơ bản
  FULL = 'full', // Nội thất đầy đủ
  SEMI = 'semi', // Nội thất cao cấp
}

export const FURNITURE_STATUS_OPTIONS = [
  { label: 'Bàn giao thô', value: FURNITURE_STATUS.NONE },
  { label: 'Hoàn thiện cơ bản', value: FURNITURE_STATUS.BASIC },
  { label: 'Nội thất đầy đủ', value: FURNITURE_STATUS.FULL },
  { label: 'Nội thất cao cấp', value: FURNITURE_STATUS.SEMI },
]

// ─── Room / Bathroom count options ────────────────────────────────────────────
export const ROOM_COUNT_OPTIONS = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4+', value: 4 },
]
